import { MemberService } from "components/member-service/MemberService";
import CardTemplate from "components/card/card-template/CardTemplate";
import { HoursOperation } from "components/hours-operation/HoursOperation";
import { DTO_SESSION_TIMEOUT } from "constants/sessionTimeouts";
import { useProductContext } from "context/ProductContext";
import { useCampaignSearch } from "hooks/useCampaignSearch";
import { redirectFromExitCard } from "utils/giwlUrl";

interface SessionExpiredCardProps {
    beginUrl?: string;
}

const SessionExpiredCard = ({ beginUrl = "/invitation" }: SessionExpiredCardProps) => {
    const timeoutInMinutes = DTO_SESSION_TIMEOUT / (60 * 1000);
    const { config, isGIWL } = useProductContext();
    const campaignSearch = useCampaignSearch();

    return (
        <CardTemplate title="Session Expired" className="text-base-content min-h-[308px] tablet:min-h-[308px]">
            <div data-testid="session-expired-content" className="font-medium text-base-content text-base flex flex-col gap-5">
                <p className="text-base leading-6 tracking-normal text-base-content">
                    Your session has expired due to {timeoutInMinutes} minutes of inactivity. If you would like to complete an
                    application, please select "Begin Another Application" below.
                </p>

                <p className="text-sm leading-5 tracking-normal text-base-content">{config.sessionExpiredText}</p>

                <div className="flex justify-center mt-2">
                    <button
                        data-testid="begin-button"
                        className="btn btn-primary h-[36px] w-[216px]"
                        onClick={() => redirectFromExitCard(isGIWL, beginUrl, campaignSearch)}
                    >
                        Begin Another Application
                    </button>
                </div>

                <MemberService email={true} titleClassName="text-black/90" />

                <HoursOperation className="text-black/90" />
            </div>
        </CardTemplate>
    );
};

export default SessionExpiredCard;
